import React from 'react';
import { Clock, Users, Settings, Calendar } from 'lucide-react';

const TimingResourcesSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  teamLocations 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Clock className="w-5 h-5 mr-2 text-indigo-500" />
        Сроки и ресурсы
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Срок разработки */}
        <div>
          <label htmlFor="projectDuration" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Calendar className="w-4 h-4 mr-2 text-indigo-500" />
            Срок разработки (месяцев)
          </label>
          <input
            type="text"
            id="projectDuration"
            name="projectDuration"
            value={formData.projectDuration}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.projectDuration ? 'input-error' : ''}`}
            placeholder="Например: 4"
          />
          {errors.projectDuration && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.projectDuration}
            </p>
          )}
        </div>

        {/* Месяцы обслуживания */}
        <div>
          <label htmlFor="maintenanceMonths" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Период обслуживания (месяцев)
          </label>
          <input
            type="text"
            id="maintenanceMonths"
            name="maintenanceMonths"
            value={formData.maintenanceMonths}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.maintenanceMonths ? 'input-error' : ''}`}
            placeholder="Например: 6"
          />
          {errors.maintenanceMonths && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.maintenanceMonths}
            </p>
          )}
        </div>

        {/* Расположение команды */}
        <div>
          <label htmlFor="teamLocation" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Users className="w-4 h-4 mr-2 text-indigo-500" />
            Расположение команды
          </label>
          <select
            id="teamLocation"
            name="teamLocation"
            value={formData.teamLocation}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.teamLocation ? 'input-error' : ''}`}
          >
            {teamLocations.map((location) => (
              <option key={location.id} value={location.id}>
                {location.name}
              </option>
            ))}
          </select>
          {errors.teamLocation && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.teamLocation}
            </p>
          )}
        </div>

        {/* Временные ограничения */}
        <div>
          <label htmlFor="timeConstraint" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Settings className="w-4 h-4 mr-2 text-indigo-500" />
            Временные ограничения
          </label>
          <select
            id="timeConstraint"
            name="timeConstraint"
            value={formData.timeConstraint}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="relaxed">Без спешки</option>
            <option value="normal">Стандартные сроки</option>
            <option value="fast">Быстрая разработка</option>
            <option value="urgent">Срочный проект</option>
          </select>
        </div>
      </div>

      <div className="mt-4 bg-amber-50 dark:bg-amber-900/20 p-3 rounded-lg border border-amber-100 dark:border-amber-800">
        <div className="flex items-start">
          <Clock className="w-5 h-5 text-amber-600 dark:text-amber-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-amber-700 dark:text-amber-300 mb-1">
              Важно о сроках
            </h4>
            <p className="text-xs text-amber-600 dark:text-amber-400">
              Срочная разработка увеличивает стоимость проекта из-за необходимости привлечения дополнительных ресурсов. Расположение команды влияет на затраты, при этом международные команды могут обеспечить оптимальный баланс цены и качества.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimingResourcesSection;